import axios from 'axios';
import buildUrl from 'build-url-ts';
import { FETCH_SCENARIOS, FETCHING_SCENARIOS_SUCCEEDED, FETCHING_SCENARIOS_FAILED, INVALIDATE_SCENARIOS, FETCH_SCENARIO, FETCHING_SCENARIO_SUCCEEDED, FETCHING_SCENARIO_FAILED, INVALIDATE_SCENARIO } from '../actionTypes';
import { createAction } from "@reduxjs/toolkit";
import { takeEvery, call, put } from "redux-saga/effects";
import { FetchScenarioErrorResponse, FetchScenariosErrorResponse, FetchScenariosRequest, FetchScenariosResponse, Scenario, UpdateScenarioErrorResponse, UpdateScenarioRequest, UpdateScenarioResponse } from 'src/types/simulation/scenarios';
import { UPDATE_SCENARIO, UPDATING_SCENARIO_SUCCEEDED, UPDATING_SCENARIO_FAILED } from '../actionTypes';

// eslint-disable-next-line no-undef
const apiUrl = process.env.REACT_APP_SIMULATION_API_URL;

export const fetchScenarios = createAction<FetchScenariosRequest>(FETCH_SCENARIOS);
const fetchingScenariosSucceeded = createAction<FetchScenariosResponse>(FETCHING_SCENARIOS_SUCCEEDED);
const fetchingScenariosFailed = createAction<FetchScenariosErrorResponse>(FETCHING_SCENARIOS_FAILED);

const fetchScenariosSaga = function* (action: ReturnType<typeof fetchScenarios>): any {
  const { page, limit } = action.payload as FetchScenariosRequest;

  const url = buildUrl(apiUrl, {
    path: `/simulations/1.0/scenarios`,
    queryParams: {
      page, limit
    }
  });

  const fetchScenariosApi = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchScenariosApi);
    yield put(fetchingScenariosSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchingScenariosFailed({
      error: error,
    }));
  }
}

export const invalidateScenarios = createAction<void>(INVALIDATE_SCENARIOS);

/**
 * Fetch scenario for id
 * 
*/
export const fetchScenario = createAction<string>(FETCH_SCENARIO);
const fetchingScenarioSucceeded = createAction<Scenario>(FETCHING_SCENARIO_SUCCEEDED);
const fetchingScenarioFailed = createAction<FetchScenarioErrorResponse>(FETCHING_SCENARIO_FAILED);

const fetchScenarioSaga = function* (action: ReturnType<typeof fetchScenario>): any {
  const id = action.payload as string;

  const url = buildUrl(apiUrl, {
    path: `/simulations/1.0/scenarios/${id}`
  });

  const fetchScenarioApi = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchScenarioApi);
    yield put(fetchingScenarioSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchingScenarioFailed({
      id: id,
      error: error,
    }));
  }
}

export const invalidateScenario = createAction<string>(INVALIDATE_SCENARIO);

export const updateScenario = createAction<UpdateScenarioRequest>(UPDATE_SCENARIO);
  const updatingScenarioSucceeded = createAction<UpdateScenarioResponse>(UPDATING_SCENARIO_SUCCEEDED);
  const updatingScenarioFailed = createAction<UpdateScenarioErrorResponse>(UPDATING_SCENARIO_FAILED);

  const updateScenarioSaga = function* (action: ReturnType<typeof updateScenario>): any {
    const {id, request} = action.payload as UpdateScenarioRequest;

    const url = buildUrl(apiUrl, {
      path: `/api/1.0/scenarios/${id}`
    });

    const updateScenarioApi = () => {
      return axios({
        method: 'PUT',
        url: url,
        data: request
      }).then((response) => response.data);
    };

    try {
      const response = yield call(updateScenarioApi);
      yield put(updatingScenarioSucceeded({
        response
      }));
    } catch (error) {
      console.log(error);
      yield put(updatingScenarioFailed({
        id: id,
        error: error,
      }));
    }
  }


export default function* scenariosSaga() {
  yield takeEvery(UPDATE_SCENARIO, updateScenarioSaga);
  yield takeEvery(FETCH_SCENARIOS, fetchScenariosSaga);
  yield takeEvery(FETCH_SCENARIO, fetchScenarioSaga);
}